var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.src)?_c('v-image',{attrs:{"config":{ ..._vm.config , ..._vm.imageConfig}},on:{"dragstart":(e) => _vm.$emit('dragstart', e),"dragend":(e) => _vm.$emit('dragend', e),"dblclick":(e) => _vm.$emit('dblclick', e),"click":(e) => _vm.$emit('click', e)}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }